import { RefObject, useEffect, useState } from 'react';

import { AboveComponentOrientationTypes } from '../@types/AboveComponentOrientationTypes';
import { AboveComponentBoxPositionTypes } from '../@types/AboveComponentBoxPositionTypes';

type TUseAboveElementPossiblePositionProps = {
  orientation: AboveComponentOrientationTypes;
  visible: boolean;
  boxId: string;
  containerRef: RefObject<HTMLDivElement>;
};

export const useAboveElementPossiblePosition = ({
  orientation,
  visible,
  boxId,
  containerRef,
}: TUseAboveElementPossiblePositionProps): AboveComponentBoxPositionTypes => {
  const [position, setPosition] =
    useState<AboveComponentBoxPositionTypes>('top');

  useEffect(() => {
    const box = document.getElementById(boxId);
    if (visible && box && containerRef.current) {
      const tooltipRect = box.getBoundingClientRect();
      const containerRect = containerRef.current.getBoundingClientRect();

      switch (orientation) {
        case 'vertical': {
          if (containerRect.top < tooltipRect.height + 10) {
            setPosition('bottom');
          } else {
            setPosition('top');
          }

          break;
        }

        case 'horizontal': {
          const spaceRight = window.innerWidth - containerRect.right;
          const spaceLeft = containerRect.left;

          if (spaceRight >= tooltipRect.width + 10) {
            setPosition('right');
          } else if (spaceLeft >= tooltipRect.width + 10) {
            setPosition('left');
          } else {
            setPosition('right');
          }
          break;
        }

        default: {
          break;
        }
      }
    }
  }, [boxId, containerRef, orientation, visible]);

  return position;
};
